module.exports = __webpack_public_path__ + "static/media/report.453662e8.svg";